<template>
  <main class="wallet-nft-asset-view-page">
    <AppNavBar :title="t('wallet.nftAssetView')" />

    <section class="asset-preview">
      <app-image v-if="assetInfo.img" :src="assetInfo.img" alt="" />
      <div v-else class="asset-preview__fallback">
        <app-image :src="emptyImage" alt="" />
      </div>
    </section>

    <section class="asset-meta">
      <p>#{{ assetInfo.tokenId || '--' }}</p>
    </section>

    <footer class="asset-footer">
      <van-button block round type="primary" @click="goSendNft">
        {{ t('wallet.sendNft') }}
      </van-button>
    </footer>
  </main>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import emptyImage from '@/assets/images/emptydata_gray.png';
import { useWalletNftStore } from '@/stores/wallet-nft';

const { t } = useI18n();
const router = useRouter();
const walletNftStore = useWalletNftStore();

const assetInfo = computed(() => walletNftStore.currentNftAsset || {});

onMounted(() => {
  if (!assetInfo.value?.tokenId && !assetInfo.value?.img) {
    router.replace('/wallet/nft-detail');
  }
});

function goSendNft() {
  router.push('/wallet/nft-send');
}
</script>

<style scoped lang="scss">
.wallet-nft-asset-view-page {
  min-height: var(--app-viewport-height);
  background: #fff;
  padding-bottom: calc(96px + env(safe-area-inset-bottom));
}

.asset-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  padding: 15px;
  background: #f5f5f5;

  .app-image {
    max-width: 100%;
    max-height: 100%;
    display: block;
    object-fit: contain;
    border-radius: 8px;
  }
}

.asset-preview__fallback {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #f5f5f5;

  .app-image {
    width: 72px;
    height: 72px;
    object-fit: contain;
  }
}

.asset-meta {
  padding: 15px;
  flex: 1;

  p {
    margin: 0;
    color: #999999;
    font-size: 14px;
    line-height: 20px;
  }
}

.asset-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px 15px calc(50px + env(safe-area-inset-bottom));
  background: #fff;

  :deep(.van-button) {
    height: 50px;
    font-size: 16px;
    font-weight: 500;
    background: #3069ff;
    border-color: #3069ff;
    box-shadow: 0 6px 16px rgba(48, 105, 255, 0.24);
  }
}
</style>
